import styled from 'styled-components';

import { Button as CommonButton } from '@rewardopl/react-ui/button/index.styles';

const fbColors = {
  primary: '#1877f2',
  primaryDark: '#0c64b6',
};

export const Button = styled(CommonButton)`
  --fb-primary: ${fbColors.primary};
  --fb-dark: ${fbColors.primaryDark};
  display: inline-block;
  background: var(--fb-primary);
  color: white;

  &:hover, &:focus {
    background: var(--fb-dark);
    color: white;
  }

  &:focus-visible {
    background: var(--fb-dark);
    color: white;
  }
`;

export const Icon = styled.img`
  width: 20px;
  height: 20px;
  margin-right: 12px;
  vertical-align: -26%;
`;
